import devConfig from './dev';
import prodConfig from './prod';
const NODE_ENV = process.env.NODE_ENV;
const useConfig = NODE_ENV === 'production' ? prodConfig : devConfig;
export default {
    ...useConfig,
    resourceHost: 'https://pic.jiangxin-food.com',
}